import { Button, Column, Columns } from '@codeparva/ui-components-library';
import React from 'react';
import { weakKey } from '../../../../../../utilities/weakKey';
import { UnitAvailabilityTypes } from '../../UnitAvailabilityTypes';
import { HorizontalAndVerticalCardConfig } from '../constants/horizontalAndVerticalCardConfig';
import { phoneNumberRedirect } from './phoneNumberRedirectHelper';
import { navigate } from 'gatsby';
import { useWindowDimensions } from '../../../../../../utilities/Dimensions';
import { tabletscreensize } from '../../../../../../utilities/constants';
import { useUnitAvailabilityContext } from '../hooks/unitAvailabilityContext';
import { Icon } from '../../../../../../utilities/icomoon-css';
import { ALERT_MODAL_CONFIG } from '../constants/viewRatesFilterConfig';
import { readCookie } from '../../../selectLocations/helper/cookieHelpers';

export const GenericCTAButtonComponentHelper = ({
  UnitAvailabilityConfig,
  data,
  onSetIndividualData,
  facilityIdDetails,
}: UnitAvailabilityTypes.GenericCTAConfig) => {
  const {
    bevStatus,
    locationStrapiId,
    facilityName,
    globalContext,
  } = useUnitAvailabilityContext();
  const {
    tfw: {
      reservation = { is_enabled: false },
      move_in = { is_enabled: false },
    } = {},
    overbookedcount,
    vacantUnitsCount: { total_count },
    unitTypeID,
    isPaymentEnabled,
    reservedUnitsCount: { total_count: reservedUnitsCount },
  } = data;

  const { width } = useWindowDimensions();
  const currViewRatesPath = location.pathname.replace(/\/$/, '');
  const { is_enabled: is_enabled_reservation = false } = reservation ?? {
    is_enabled: false,
  };
  const { is_enabled: is_enabled_move_in = false } = move_in ?? {
    is_enabled: false,
  };

  const handleNavigation = (path: string, source: string) => {
    navigate(path, {
      state: {
        individualUnitTypeData: data,
        clickedPath: source,
        locationStrapiId,
        facilityName,
      },
    });
  };

  const handleClick = (path: string, source: string) => {
    const { loggedInFacilityId, selectedFacilityId } = facilityIdDetails || {};
    const currentDate = new Date();
    const expiry = readCookie('cTokenExpiry');
    const decodedExpiry = !!expiry ? decodeURIComponent(expiry) : null;
    const expiryDate = !!decodedExpiry ? new Date(decodedExpiry) : null;

    if (onSetIndividualData) {
      onSetIndividualData(data);
    }

    if (readCookie('cToken') && expiryDate && currentDate <= expiryDate) {
      if (loggedInFacilityId === selectedFacilityId) {
        handleNavigation(path, source);
      } else {
        globalContext?.setAlertModalInfo({
          showModal: true,
          currentUnitTypeData: data,
          type:
            source === 'move-in'
              ? ALERT_MODAL_CONFIG.rent
              : ALERT_MODAL_CONFIG.reserve,
        });
      }
    } else {
      handleNavigation(path, source);
    }
  };

  const nextRouteUrl =
    width >= tabletscreensize && bevStatus
      ? `${currViewRatesPath}/${HorizontalAndVerticalCardConfig.urls.bev}`
      : `${currViewRatesPath}/${HorizontalAndVerticalCardConfig.urls.moveIn}`;

  const ReserveButton = () => {
    return (
      <Button
        className={`CTAButton cp-primary-button-highlighted subtitle1`}
        data-cy={`ViewRatesReserveCTA-${unitTypeID}`}
        isLink
        onClick={() =>
          handleClick(
            `${currViewRatesPath}/${HorizontalAndVerticalCardConfig.urls.reservation}`,
            'reserve'
          )
        }
      >
        Reserve
      </Button>
    );
  };

  const MoveInButton = () => {
    return (
      <Button
        className={`CTAButtonOutlined cp-outline-button-highlighted subtitle1`}
        data-cy={`ViewRatesMoveInCTA-${unitTypeID}`}
        isLink
        onClick={() => handleClick(nextRouteUrl, 'move-in')}
      >
        Rent
      </Button>
    );
  };

  const isMoveInAllowed = () => {
    return is_enabled_move_in && total_count >= 1 && isPaymentEnabled;
  };

  const isReservationAllowed = () => {
    return (
      is_enabled_reservation &&
      reservedUnitsCount < total_count + overbookedcount &&
      isPaymentEnabled
    );
  };

  const isReservationOrMoveInAllowed = () => {
    return isReservationAllowed() || isMoveInAllowed();
  };

  const CallToFacilityButton = ({
    element,
  }: UnitAvailabilityTypes.TIndividualData) => {
    if (isReservationOrMoveInAllowed()) {
      return (
        <Columns className="is-flex" multiline={false}>
          {isMoveInAllowed() && (
            <Column>
              <MoveInButton />
            </Column>
          )}
          {isReservationAllowed() && (
            <Column>
              <ReserveButton />
            </Column>
          )}
        </Columns>
      );
    }
    //  else if (
    //   total_count >= 1 &&
    //   is_enabled_move_In &&
    //   !is_enabled_reservation
    // ) {
    //   return <ReserveButton />;
    // } else if (
    //   total_count >= 1 &&
    //   !is_enabled_reservation &&
    //   is_enabled_move_In
    // ) {
    //   return <MoveInButton />;
    // }
    else if (!is_enabled_reservation || !isPaymentEnabled) {
      return (
        <a
          href={phoneNumberRedirect(
            element.callToActionButtons[0].callToAction.link
          )}
          key={weakKey(element)}
        >
          <Button className={`CTAButton cp-primary-button-highlighted`}>
            {element.callToActionButtons[0].callToAction.label}
          </Button>
        </a>
      );
    } else {
      return (
        <a
          href={phoneNumberRedirect(
            element.callToActionButtons[0].callToAction.link
          )}
          key={weakKey(element)}
        >
          <Button className={`CTAButton cp-primary-button-highlighted`}>
            {element.callToActionButtons[0].callToAction.label}
          </Button>
        </a>
      );
    }
  };
  return (
    <div>
      {UnitAvailabilityConfig.unitTypeData.map(element => {
        return (
          <CallToFacilityButton element={element} key={weakKey(element)} />
        );
      })}
    </div>
  );
};

export const ViewRatesAmenitiesCTA = ({
  index,
  viewCTAStatus,
  setViewCTAStatus,
}: UnitAvailabilityTypes.TViewRatesAmenitiesCTA) => {
  const onDropDownCTA = React.useCallback(
    (selectedIndex: number) => {
      if (selectedIndex === index) {
        setViewCTAStatus(!viewCTAStatus);
      }
    },
    [viewCTAStatus]
  );
  return (
    <button
      className="button viewCTAButton pl-0 is-flex is-justify-content-flex-start"
      onClick={() => {
        onDropDownCTA(index);
      }}
    >
      <span className="dropdownText pr-2">
        {viewCTAStatus ? 'View Less' : 'View More'}
      </span>
      <Icon
        name={viewCTAStatus ? 'tfw-arrow-up-2-cp' : 'tfw-arrow-down-2-cp'}
        size={24}
        title={viewCTAStatus ? 'tfw-arrow-up-2-cp' : 'tfw-arrow-down-2-cp'}
      />
    </button>
  );
};
